module.exports = __webpack_public_path__ + "fonts/7f7d086.otf";